import { Component, OnInit } from '@angular/core';
import { TermsOfUseService } from '../../services/terms-of-use.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-of-use',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css'],
  providers: [TermsOfUseService]
})
export class TermsOfUseComponent implements OnInit {

  termsOfUse: any;

  constructor(private termsOfUseService: TermsOfUseService) { }

  ngOnInit() {
    this.termsOfUseService.getTermsOfUse().subscribe(data => {
      this.termsOfUse = data;
    });
  }

}
